var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.imageWidth,"height":_vm.imageHeight,"viewBox":_vm.viewBox,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.imagePath,"fill":_vm.fill}})])}
var staticRenderFns = []

export { render, staticRenderFns }